import { cn } from "@wa/ui";

/**
 * Two capitals out of a name. Legal-form suffixes are dropped first, so a
 * company initialises on its two distinguishing words instead of picking up the
 * form of incorporation, which every second company in the list shares.
 */
const SUFFIX = /^(o[üu]|as|mt[üu]|fie|tuk|ltd|oy|ab|gmbh|sia|uab)$/i;

export function initials(name: string | null | undefined): string {
  const words = (name ?? "")
    .replace(/["'`]/g, " ")
    .split(/[\s.,/-]+/)
    .filter((w) => w && !SUFFIX.test(w));
  if (!words.length) return "?";
  if (words.length === 1) return words[0]!.slice(0, 2).toUpperCase();
  return (words[0]![0]! + words[1]![0]!).toUpperCase();
}

export type AvatarTone = "brand" | "soft" | "alt";

/**
 * The initials disc. `soft` is the tinted version used in lists, where a page
 * full of saturated gradients would read as confetti; `brand` is for the one
 * person or record the screen is actually about.
 */
export function Avatar({
  name,
  src,
  tone = "soft",
  size = 38,
  className,
}: {
  name: string | null | undefined;
  src?: string | null;
  tone?: AvatarTone;
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={cn("crm-av", tone === "soft" && "crm-av-soft", tone === "alt" && "crm-av-alt", className)}
      style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.33)) }}
      aria-hidden
    >
      {src ? <img src={src} alt="" draggable={false} /> : initials(name)}
    </span>
  );
}
